<template>
  <div class="admin-panel">
    <div class="admin-panel-fixbox">
      <button class="admin-nav-trigger navbar-toggler p-0" data-toggle="collapse" data-target="#nav">
        <i class="admin-nav-trigger-icon fas fa-bars"></i>
      </button>
      <div class="ht-section ht-section-top-bar">
        <div class="ht-container ml-2 pt-0 pb-0">
          <div class="nav-logo">hometender</div>
          <div class="session-box">
            <a href="" class="nav-toggle">
              <img :src="gravatarUrl()" class="mr-1 border rounded" width="40" />
            </a>
          </div>
        </div>
      </div>
      <div class="admin-page-header">
        <div class="ht-container ht-container-admin">
          <div class="flex flex-wrap justify-between items-center">
            <div class="admin-page-title mr-2 flex-auto">
              <h2>{{ $route.meta.title }}</h2>
            </div>
          </div>
        </div>
      </div>

      <div class="admin-content">
        <router-view class="view"></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import * as crypto from 'crypto';

@Component
class PageWithNavbar extends Vue {
  gravatarUrl() {
    if (this.$store.state.auth && this.$store.state.auth.status && this.$store.state.auth.status.loggedIn) {
      const md5 = crypto.createHash('md5').update(this.$store.state.auth.user.email).digest("hex");
      return "https://www.gravatar.com/avatar/" + md5;
    } else {
      return "https://www.gravatar.com/avatar/12345";
    }
  }
}
export default PageWithNavbar;
</script>

<style scoped>
.nav-logo {
  display: flex;
  float: left;
  margin-left: 0.4rem;
  margin-top: 0.7rem;
  font-size: 1.4rem;
  letter-spacing: 0.15rem;
  color: #72737c;
}

.nav-toggle {
  height: 3.75rem;
  margin-right: 0;
  padding-right: .8rem;
  padding-left: .8rem;
  position: relative;
  cursor: pointer;
  text-align: left;
  background-color: transparent;
  font-size: .75rem;
  font-weight:700
}

.nav-toggle:focus, .nav-toggle:hover {
  outline: none;
}

.nav-toggle:after {
  content: "";
  width: 7px;
  height: 7px;
  border-right: .13rem solid;
  border-top: .13rem solid;
  transform: rotate(135deg);
  transition-property: transform, opacity, top;
  transition-duration: .05s;
  transition-timing-function: ease-in-out;
  position: absolute;
  top: calc(50% - 5.5px);
  right: 2px;
  opacity:.5
}

.nav-toggle.active:after {
  transform: rotate(-45deg);
  top: calc(50% - 2.5px);
}

.session-box {
  margin-top: 0.7rem;
  float: right;
  position: relative;
}

.session-box > a {
  text-decoration: none;
}
</style>
